import type { JSX } from 'react';

import React from 'react';

import { classNames } from '../../../utils/class-names';

import styles from './table-row.module.css';

export type TableRowProps = {
  highlightOnHover?: boolean;
  focusable?: boolean;
} & JSX.IntrinsicElements['tr'];

/**
 * @param {boolean} [highlightOnHover] - Whether to highlight the row on hover or not.
 * @param {boolean} [focusable] - Whether to make the row focusable or not.
 */
export function TableRow({ id, className, highlightOnHover, focusable, ...props }: TableRowProps) {
  return (
    <tr
      tabIndex={focusable ? 0 : undefined}
      data-testid={id}
      className={classNames(className, highlightOnHover && styles.highlightRow)}
      {...props}
    />
  );
}
